var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Pipe } from '@angular/core';
var ThousandPipe = /** @class */ (function () {
    function ThousandPipe() {
    }
    ThousandPipe.prototype.transform = function (value) {
        var number = 0;
        if (value) {
            number = value.toLocaleString();
        }
        return number;
    };
    ThousandPipe = __decorate([
        Pipe({
            name: 'thousand',
        })
    ], ThousandPipe);
    return ThousandPipe;
}());
export { ThousandPipe };
//# sourceMappingURL=thousand.js.map


// WEBPACK FOOTER //
// ./src/pipes/thousand/thousand.ts.pre-build-optimizer.js